import React from 'react';

function DatenschutzPage() {
  return (
    <div className="container mx-auto px-4 lg:px-12 py-8 max-w-4xl">
      <h1 className="text-3xl md:text-4xl font-heading font-bold mb-8 uppercase">
        Datenschutzerklärung
      </h1>

      <div className="prose prose-gray max-w-none space-y-8">
        {/* 1. Datenschutz auf einen Blick */}
        <section>
          <h2 className="text-xl font-bold mb-4">1. Datenschutz auf einen Blick</h2>
          <h3 className="text-lg font-semibold mb-2 mt-4">Allgemeine Hinweise</h3>
          <p className="text-gray-700">
            Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
            personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
            Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
          </p>
          <p className="text-gray-700 mt-2">
            Diese Website richtet sich ausschließlich an Gewerbetreibende (B2B). Die 
            Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber.
          </p>
        </section>

        {/* 2. Verantwortlicher */}
        <section>
          <h2 className="text-xl font-bold mb-4">2. Verantwortlicher</h2>
          <p className="text-gray-700">
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:
          </p>
          <p className="text-gray-700 mt-4">
            ED STEEL<br />
            Inhaber: Erkan Deniz<br />
            <br />
            Telefon: +49 171 629 5816<br />
            E-Mail: ed-steel@outlook.de
          </p>
          <p className="text-gray-700 mt-4">
            Verantwortliche Stelle ist die natürliche oder juristische Person, die allein oder 
            gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung von personenbezogenen 
            Daten entscheidet.
          </p>
        </section>

        {/* 3. Datenerfassung auf dieser Website */}
        <section>
          <h2 className="text-xl font-bold mb-4">3. Datenerfassung auf dieser Website</h2>
          
          <h3 className="text-lg font-semibold mb-2 mt-4">Server-Log-Dateien</h3>
          <p className="text-gray-700">
            Der Provider dieser Seiten erhebt und speichert automatisch Informationen in 
            sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. 
            Dies sind:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>Browsertyp und Browserversion</li>
            <li>Verwendetes Betriebssystem</li>
            <li>Referrer URL</li>
            <li>Hostname des zugreifenden Rechners</li>
            <li>Uhrzeit der Serveranfrage</li>
            <li>IP-Adresse</li>
          </ul>
          <p className="text-gray-700 mt-2">
            Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.
          </p>
          <p className="text-gray-700 mt-2">
            Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. 
            Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien 
            Darstellung und der Optimierung seiner Website.
          </p>
        </section>

        {/* 4. Kundenkonto und Bestellungen */}
        <section>
          <h2 className="text-xl font-bold mb-4">4. Kundenkonto und Bestellabwicklung</h2>
          <p className="text-gray-700">
            Wenn Sie ein Kundenkonto eröffnen oder eine Bestellung aufgeben, erheben wir 
            folgende Daten:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>Firmenname</li>
            <li>Ansprechpartner (Name)</li>
            <li>E-Mail-Adresse</li>
            <li>Telefonnummer</li>
            <li>Liefer- und Rechnungsadresse</li>
            <li>Bestellhistorie</li>
            <li>Zahlungsinformationen (abhängig von der Zahlungsart)</li>
          </ul>
          <p className="text-gray-700 mt-2">
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) sowie Art. 6 
            Abs. 1 lit. c DSGVO (rechtliche Verpflichtungen, z.B. Aufbewahrungspflichten).
          </p>
          <p className="text-gray-700 mt-2">
            Die Daten werden nach Ablauf der gesetzlichen Aufbewahrungsfristen gelöscht, 
            sofern keine anderen rechtlichen Gründe einer Löschung entgegenstehen.
          </p>
        </section>

        {/* 5. Zahlungsdienstleister */}
        <section>
          <h2 className="text-xl font-bold mb-4">5. Zahlungsdienstleister</h2>
          
          <h3 className="text-lg font-semibold mb-2 mt-4">Stripe</h3>
          <p className="text-gray-700">
            Für die Zahlungsabwicklung nutzen wir den Dienst Stripe (Stripe Inc., 510 Townsend 
            Street, San Francisco, CA 94103, USA). Bei Auswahl einer Zahlungsart über Stripe 
            werden die zur Zahlungsabwicklung erforderlichen Daten an Stripe übermittelt.
          </p>
          <p className="text-gray-700 mt-2">
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung).
          </p>
          <p className="text-gray-700 mt-2">
            Weitere Informationen zum Datenschutz bei Stripe finden Sie unter:{' '}
            <a 
              href="https://stripe.com/de/privacy" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              https://stripe.com/de/privacy
            </a>
          </p>

          <h3 className="text-lg font-semibold mb-2 mt-4">PayPal</h3>
          <p className="text-gray-700">
            Bei Zahlung via PayPal werden Ihre Zahlungsdaten an PayPal (Europe) S.à r.l. et 
            Cie, S.C.A., 22-24 Boulevard Royal, L-2449 Luxembourg, übermittelt.
          </p>
          <p className="text-gray-700 mt-2">
            Weitere Informationen zum Datenschutz bei PayPal finden Sie unter:{' '}
            <a 
              href="https://www.paypal.com/de/webapps/mpp/ua/privacy-full" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-primary hover:underline"
            >
              https://www.paypal.com/de/webapps/mpp/ua/privacy-full
            </a>
          </p>
        </section>

        {/* 6. Weitergabe von Daten */}
        <section>
          <h2 className="text-xl font-bold mb-4">6. Weitergabe von Daten</h2>
          <p className="text-gray-700">
            Eine Weitergabe Ihrer Daten erfolgt nur, soweit dies zur Vertragserfüllung 
            erforderlich ist, insbesondere an:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li>Versanddienstleister (DHL, DPD, Hermes, Speditionen) zur Lieferung der Ware</li>
            <li>Zahlungsdienstleister (Stripe, PayPal) zur Zahlungsabwicklung</li>
            <li>Hosting-Provider für den Betrieb der Website</li>
            <li>Ggf. Großhändler zur Auftragsabwicklung (Fripac Medis)</li>
          </ul>
          <p className="text-gray-700 mt-2">
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
          </p>
        </section>

        {/* 7. Cookies */}
        <section>
          <h2 className="text-xl font-bold mb-4">7. Cookies</h2>
          <p className="text-gray-700">
            Diese Website verwendet Cookies. Cookies sind kleine Textdateien, die auf Ihrem 
            Endgerät gespeichert werden. Sie richten keinen Schaden an.
          </p>
          <p className="text-gray-700 mt-2">
            Wir verwenden folgende Arten von Cookies:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li><strong>Technisch notwendige Cookies:</strong> Diese sind für den Betrieb der 
            Website erforderlich (z.B. Session-Cookies, Login-Status).</li>
            <li><strong>Funktionale Cookies:</strong> Diese speichern Ihre Einstellungen 
            (z.B. Sprachauswahl).</li>
          </ul>
          <p className="text-gray-700 mt-2">
            Rechtsgrundlage für technisch notwendige Cookies ist Art. 6 Abs. 1 lit. f DSGVO 
            (berechtigtes Interesse).
          </p>
          <p className="text-gray-700 mt-2">
            Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies 
            informiert werden. Dadurch wird die Nutzung der Website für Sie jedoch 
            möglicherweise eingeschränkt.
          </p>
        </section>

        {/* 8. Hosting */}
        <section>
          <h2 className="text-xl font-bold mb-4">8. Hosting</h2>
          <p className="text-gray-700">
            Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die 
            personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den 
            Servern des Hosters gespeichert.
          </p>
          <p className="text-gray-700 mt-2">
            Der Einsatz des Hosters erfolgt im Interesse einer sicheren, schnellen und 
            effizienten Bereitstellung unseres Online-Angebots. Rechtsgrundlage ist Art. 6 
            Abs. 1 lit. f DSGVO.
          </p>
        </section>

        {/* 9. Ihre Rechte */}
        <section>
          <h2 className="text-xl font-bold mb-4">9. Ihre Rechte</h2>
          <p className="text-gray-700">
            Sie haben gegenüber uns folgende Rechte hinsichtlich der Sie betreffenden 
            personenbezogenen Daten:
          </p>
          <ul className="list-disc list-inside text-gray-700 mt-2 space-y-1">
            <li><strong>Auskunftsrecht</strong> (Art. 15 DSGVO)</li>
            <li><strong>Recht auf Berichtigung</strong> (Art. 16 DSGVO)</li>
            <li><strong>Recht auf Löschung</strong> (Art. 17 DSGVO)</li>
            <li><strong>Recht auf Einschränkung der Verarbeitung</strong> (Art. 18 DSGVO)</li>
            <li><strong>Recht auf Datenübertragbarkeit</strong> (Art. 20 DSGVO)</li>
            <li><strong>Widerspruchsrecht</strong> (Art. 21 DSGVO)</li>
          </ul>
          <p className="text-gray-700 mt-4">
            Zur Geltendmachung Ihrer Rechte wenden Sie sich bitte an: ed-steel@outlook.de
          </p>
        </section>

        {/* 10. Widerruf Ihrer Einwilligung */}
        <section>
          <h2 className="text-xl font-bold mb-4">10. Widerruf Ihrer Einwilligung</h2>
          <p className="text-gray-700">
            Sofern die Verarbeitung Ihrer Daten auf einer Einwilligung beruht, haben Sie das 
            Recht, diese Einwilligung jederzeit mit Wirkung für die Zukunft zu widerrufen.
          </p>
        </section>

        {/* 11. Beschwerderecht */}
        <section>
          <h2 className="text-xl font-bold mb-4">11. Beschwerderecht bei der Aufsichtsbehörde</h2>
          <p className="text-gray-700">
            Sie haben das Recht, sich bei einer Datenschutz-Aufsichtsbehörde über die 
            Verarbeitung Ihrer personenbezogenen Daten zu beschweren.
          </p>
        </section>

        {/* 12. Änderungen */}
        <section>
          <h2 className="text-xl font-bold mb-4">12. Aktualität und Änderung dieser Datenschutzerklärung</h2>
          <p className="text-gray-700">
            Diese Datenschutzerklärung ist aktuell gültig und hat den Stand Februar 2026.
          </p>
          <p className="text-gray-700 mt-2">
            Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher 
            bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung 
            zu ändern.
          </p>
        </section>

        {/* Stand */}
        <section className="pt-4 border-t border-gray-200">
          <p className="text-gray-500 text-sm">
            Stand: Februar 2026
          </p>
        </section>
      </div>
    </div>
  );
}

export default DatenschutzPage;
